import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { CONTEXTUAL_ENTITY_TYPE, RECOMMENDATION_TYPES } from '@bingads-webui-campaign/recommendation-core';
import { withContextualAttributeTemplate } from '@bingads-webui-campaign/recommendation-contextual-attribute';

import template from './goal-column.pug';

export class GoalColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, recommendationType, s$i18n }) {
    let sortable = false;
    if (recommendationType === RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS) {
      sortable = 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.FixConversionGoalSettingsOpportunitySummary/GoalName';
    } else if (recommendationType === RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL) {
      sortable = 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.CreateConversionGoalOpportunitySummary/GoalName';
    }
    super({
      name: 'GoalName',
      property: 'GoalName',
      title: i18n.getString('Details_View_Goal_Name'),
      bodyClasses: ['grid-column-goalName', 'actionable'],
      colClasses: ['col-normalText'],
      sortable,
      type: 'string',
    });
    this.i18n = i18n;
    this.recommendationType = recommendationType;
    this.s$i18n = s$i18n;
  }

  template({
    value: {
      Opportunities,
      Target: { AccountName },
    },
  }) {
    const { i18n, recommendationType } = this;
    const opportunity = _.first(Opportunities);
    const goalName = opportunity.GoalName;
    const campaignAttributes =
      recommendationType === RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS ?
        withContextualAttributeTemplate({
          opportunityId: opportunity.OpportunityId,
          entityName: goalName,
          entityId: opportunity.GoalId,
          entityType: CONTEXTUAL_ENTITY_TYPE.GOAL,
          status: 'false',
          ariaLabel: i18n.getString('Click to scope to goal {{goalName}}', { goalName }),
          accountName: AccountName,
          s$i18n: this.s$i18n,
        }) : goalName;

    return template({ campaignAttributes });
  }

  get property() {
    return {
      get: _.identity,
      property: 'GoalName',
    };
  }
}
